import React, { useState, useRef } from 'react';
import { SpreadsheetComponent } from '@syncfusion/ej2-react-spreadsheet';
import {
  Card,
  Col,
  Form,
  Row,
} from 'react-bootstrap';

function Table({answer}) {

  let spreadsheet = useRef(null);

  const [data, setData] = useState(JSON.parse(answer.ANSWER_DESC));

  const handleCreatedBU = () => {

    if (data === null || data === undefined) return;
    if (!spreadsheet.current) return;

    spreadsheet.current.openFromJson({ file: data });
  }

  const handleCreated = async () => {

      if (data === null || data === undefined) return;
      if (!spreadsheet.current) return;

      const response = await axios.get(
        `${process.env.REACT_APP_API_HOST}answers/${answer.ANSWER_ID}/spreadsheet`,
      );

      spreadsheet.current.openFromJson({file: response.data});
    }

  return (
    <Row>
      <Col md="12">
        <Card>
          <Card.Header>
            <Card.Title style={{fontWeight:'bold', fontSize:'20px', marginBottom:10}} as="h5">{answer.question.QUESTION_CODE}. <a style={{fontWeight:'bold'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_LABEL}} /></Card.Title>
            <div style={{whiteSpace: 'pre-wrap',marginLeft:18, marginTop:5, fontSize:'17px'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_DESC}} />
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md="10">
                <Form.Group>
                  <Form.Label>Auditee's Answer</Form.Label>
                  <SpreadsheetComponent
                    ref={spreadsheet}
                    allowEditing={false}
                    showFormulaBar={false}
                    showRibbon={false}
                    showSheetTabs={false}
                    created={handleCreated}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Attachment(s)</Form.Label>
                  {answer.answerAttachments && answer.answerAttachments.length
                    ? (
                      <span className="form-control"
                        style={{
                          maxHeight: `200px`,
                          height: `200px`,
                          overflowY: `scroll`,
                          marginBottom: `10px`
                        }}
                      >
                        {answer.answerAttachments.map((attachment, key) => (
                          <div key={key} className="font-icon-detail">
                            <i className="nc-icon nc-attach-87"></i>{' '}
                            <a href={`${process.env.REACT_APP_API_HOST}answer-attachments/${attachment.ATTACHMENT_ID}/download`} target="_blank" rel="noopener noreferrer">
                              {attachment.ATTACHMENT_NAME}.{attachment.ATTACHMENT_EXT}
                            </a>
                          </div>
                        ))}
                      </span>
                    )
                    : <p>No attachment uploaded.</p>
                  }
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}

export default Table;